const settings = {
    refinementGroupSelector: '.refinement[data-attrid]',
    refinementFiltersRootSelector: '.refinements-filters',
    selectedRefinementValueSelector: '.selected:not(.region-select)'
};

/**
 * Get selected refinements from PLP
 *
 * @param {Object} element html element where refinement are
 * @param {boolean} forTracking is this used for tracking, to get "050" intead of "Black"
 * @returns {Object} return selected refinements, where key is refinement id
 */
function getSelectedRefinements(element, forTracking) {
    const scope = element || document.body.querySelector(settings.refinementFiltersRootSelector);
    if (!scope) {
        return null;
    }
    const selectedRefinements = {};
    const refinementGroups = scope.querySelectorAll(settings.refinementGroupSelector);

    // get refinements with selected values.
    for (let i = 0; i < refinementGroups.length; i++) {
        const refinementId = refinementGroups[i].dataset.attrid;
        if (refinementId) {
            // get selected values in this group.
            const selectedValues = refinementGroups[i].querySelectorAll(settings.selectedRefinementValueSelector);
            if (selectedValues.length) {
                selectedRefinements[refinementId] = [];
                for (let v = 0; v < selectedValues.length; v++) {
                    let {refinementValue} = selectedValues[v].dataset;
                    const {presentationId} = selectedValues[v].dataset;
                    if (forTracking && presentationId && presentationId !== 'null') {
                        refinementValue = presentationId;
                    }
                    if (!selectedRefinements[refinementId].includes(refinementValue)) {
                        selectedRefinements[refinementId].push(refinementValue);
                    }
                }
            }
        }
    }

    const priceMin = scope.querySelector('input[name=pmin]');
    const priceMax = scope.querySelector('input[name=pmax]');
    const toggles = scope.querySelectorAll('input.refinement-option');
    const priceRangeSlider = scope.querySelector('#price-range-slider');

    // Check if price range filter is used
    if (priceRangeSlider && priceMin && priceMax) {
        const minDiferent =
            (priceMin && parseInt(priceMin.value) !== parseInt(priceMin.dataset.prevValue)) ||
            parseInt(priceRangeSlider.dataset.min) < parseInt(priceMin.value);
        const maxDiferent =
            (priceMax && parseInt(priceMax.value) !== parseInt(priceMax.dataset.prevValue)) ||
            parseInt(priceRangeSlider.dataset.max) > parseInt(priceMax.value);
        if (minDiferent || maxDiferent) {
            selectedRefinements.priceNotDefault = 'true';

            if (priceMin) {
                selectedRefinements.pmin = parseInt(priceMin.value);
            }
            if (priceMax) {
                selectedRefinements.pmax = parseInt(priceMax.value);
            }
        }
    }

    for (let t = 0; t < toggles.length; t++) {
        selectedRefinements[toggles[t].name] = toggles[t].checked;
    }

    return selectedRefinements;
}

module.exports = {
    getSelectedRefinements
};
